// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__bOxqW","buttons":"PendingPaymentAlert_buttons__1t80E"};